import React from 'react';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { I18nextProvider, initReactI18next } from 'react-i18next';

type IProps = {
  children: React.ReactNode;
};

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: (lng) => `/locales/${lng[0].split('-')[0]}.json`,
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export const TranslationProvider = ({ children }: IProps) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
